import { useCallback, useContext } from "react";
import Draggable from "react-draggable";

import { AssessmentSliceActions } from "@assessment/store/slices/assessmentSlice";
import { cn } from "@assessment/utils/cn";
import CameraPreviewLoader from "@assessment/components/molecules/cameraPreviewLoader";
import { ProctoringFunctionsContext } from "@assessment/contexts/proctoringFunctionsContext";

import { useAppDispatch, useAppSelector } from "../../../../store/store";

import GetHeroIcon from "../../../../utils/getHeroIcons";

const ProctoringWindow = () => {
  const dispatch = useAppDispatch();
  const context = useContext(ProctoringFunctionsContext);
  if (!context) {
    throw new Error("Context Error");
  }
  const { registerPreviewSink } = context;
  const videoPreviewLoader = useAppSelector(
    (state) => state.AssessmentSlice.videoPreviewLoader
  );

  const previewRefSetter = useCallback(
    (node: HTMLVideoElement | null) => {
      registerPreviewSink(node);
    },
    [registerPreviewSink]
  );

  return (
    <Draggable
      axis="x"
      defaultPosition={{ x: 5, y: 5 }}
      grid={[25, 25]}
      scale={1}
      bounds={{ left: 5, right: 1400 }}
    >
      <div className=" w-[356px] h-[200px] rounded-xl cursor-move">
        <div className="relative w-full h-full">
          <button
            type="button"
            className="absolute z-10 flex items-center justify-center w-6 h-6 p-1 rounded-full cursor-pointer bg-primary right-3 top-3 bg-white/50"
            onClick={() => {
              dispatch(
                AssessmentSliceActions.mutateShowProctoringVideoPreview(false)
              );
            }}
          >
            <GetHeroIcon
              name="ArrowsPointingInIcon"
              className="w-4 h-4 text-white"
            />
          </button>
          <video
            ref={previewRefSetter}
            autoPlay
            muted
            playsInline
            className={cn(
              "object-cover w-full h-full rounded-xl transition-opacity duration-150",
              videoPreviewLoader ? "opacity-0" : "opacity-100"
            )}
            disablePictureInPicture
            disableRemotePlayback
          />
          {videoPreviewLoader && (
            <div className="absolute inset-0">
              <CameraPreviewLoader className="rounded-xl" />
            </div>
          )}
        </div>
      </div>
    </Draggable>
  );
};

export default ProctoringWindow;
